import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import { getActiveAgencyUser } from '../../shared/redux/selectors';

import { parseQueryString } from '../../shared/utils';

import get from 'lodash/get';
import values from 'lodash/values';

import {
  loadAccountHistory,
  addFundsToAgency
} from '../../shared/redux/accounting/actions';

function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId)
      .filter((p) => p.kind === 'card')
      .filter((p) => p.active);
      
  } else {
    return [];
  }
}


function mapStateToProps(state,props){
  const activeUser = getActiveAgencyUser(state),
    queryStringParams = parseQueryString(props.location.search);

  return {
    agencyId:activeUser.agencyId,
    redirectURL:queryStringParams['redirect'] || null,
    currentBalance:12,
    activePaymentMethods:getPaymentMethodsForAgency(state,activeUser.agencyId)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AgencyAddFunds
  return bindActionCreators({ 
    loadAccountHistory, 
    addFundsToAgency 
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AgencyAddFunds/connect.js